var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8701 4.89L13.5601 2.44C13.5301 2.19 13.3201 2 13.0601 2H9.95011C9.70011 2 9.48011 2.19 9.45011 2.44L9.18011 4.59C9.16011 4.77 9.03011 4.93 8.86011 4.99C8.02011 5.3 7.22011 5.78 6.53011 6.4L4.25011 5.44C4.02011 5.34 3.75011 5.43 3.62011 5.65L2.06011 8.35C1.94011 8.57 2.00011 8.85 2.20011 9L4.17011 10.49C3.96011 11.5 3.96011 12.53 4.16011 13.51H4.17011L2.20011 15C2.00011 15.15 1.94011 15.43 2.07011 15.65L3.63011 18.35C3.76011 18.57 4.03011 18.66 4.26011 18.56L6.54011 17.6L6.53011 17.61C6.90011 17.94 7.32011 18.24 7.77011 18.5C8.22011 18.76 8.68011 18.97 9.16011 19.13V19.11L9.47011 21.56C9.48011 21.81 9.70011 22 9.95011 22H13.0701C13.3201 22 13.5301 21.81 13.5701 21.56L13.8401 19.41C13.8601 19.23 13.9901 19.07 14.1601 19.01C15.0001 18.7 15.8001 18.22 16.4901 17.6L18.7701 18.56C19.0001 18.66 19.2701 18.57 19.4001 18.35L20.9601 15.65C21.0901 15.43 21.0301 15.15 20.8301 15L18.8601 13.51C19.0701 12.5 19.0701 11.47 18.8701 10.49H18.8601L20.8101 9C21.0101 8.85 21.0701 8.57 20.9401 8.35L19.3801 5.65C19.2501 5.43 18.9801 5.34 18.7501 5.44L16.4801 6.4L16.4901 6.39C16.1201 6.06 15.7001 5.76 15.2501 5.5C14.8001 5.24 14.3401 5.03 13.8601 4.87",
    stroke: "#2F54EB",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5103 16C13.7194 16 15.5103 14.2091 15.5103 12C15.5103 9.79086 13.7194 8 11.5103 8C9.30111 8 7.51025 9.79086 7.51025 12C7.51025 14.2091 9.30111 16 11.5103 16Z",
    stroke: "#ADC6FF",
    strokeWidth: 1.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/SettingsIcon.ae49b20b85037073d6b624d4243918f7.svg";
export { ForwardRef as ReactComponent };